// Dependencies
window.$ = window.jQuery = require('jquery');
window.toastr = require('toastr/toastr');
window.NProgress = require('nprogress');

require('jquery-ui-dist/jquery-ui');
window.DataTable = require('datatables.net');
require('select2');
require('jquery-form');
require('bootstrap');
require('bootstrap-datepicker');
require('bootstrap-editable');
require('cookieconsent');
require('jquery-ui.combobox');

// Local dependencies
const Router = require('../_lib/core/Router');
window.latinize = require('../_lib/latinize');
window.md5 = require('../_lib/md5.min');
window.bootbox = require('../_lib/bootbox.min');

require('../_lib/jquery.language.switcher');
require('../_lib/jquery.donetyping');
require('../_lib/jquery.fileDownload');
require('../_lib/jquery.tagsinput');
require('../_lib/scrollup/jquery.scrollUp');
require('../_lib/formData');
require('../_lib/ajaxForm');
require('../_lib/loading');

// Load all src js
new Router(() => require.context('./src', true, /.js$/));
